



















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
// import { identity } from "lodash";
// import { storeSoap } from "@/store/modules/soap";
// import { storeFaskes } from "@/store/modules/faskes";
import { storeRujukan } from "@/store/modules/rujukan";
import DataRujukan from "@/services/DataRujukan";
import DataUtility from "@/services/DataUtility";
import { appModule } from "@/store/modules/app";

@Component({
  components: {
    CardModalTtd
  }
})
export default class SuratRujukanModalInput extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() tujuan: object;
  @Prop() dataRujukan: object;

  searchStringFaskes = "";
  listFaskes: object = {};
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  // tujuan = "";
  unit_tujuan_text = "";
  diagnosis = "";
  alasan = "";
  kondisi = "";
  terapi_diberikan = "";
  penunjang = "";
  terapi_diharapkan = "";
  modalTtd = false;
  alert = "";
  rujukan: object = {};
  dtRujukan: object = {};

  mounted() {
    console.log("mr", this.dataRujukan);
    this.faskesList();
  }
  // fstateFaskes() {
  //   storeFaskes.act_all();
  // }
  get dialog() {
    return this.value;
  }

  closeDialog() {
    console.log("cloase dialog");
    this.$emit("closeModal");
  }

  faskesList() {
    const faskes = DataUtility.getListFaskes();
    faskes.then(faskes => {
      this.listFaskes = faskes;
      // console.log("faskes", this.listFaskes);
    });
  }
  @Watch("dataRujukan")
  changeRujukan(value) {
    // console.log("dtRujukan", value);
    this.rujukan = value;
    this.unit_tujuan_text = this.rujukan["unit_tujuan_text"];
    this.diagnosis = this.rujukan["a"];
    this.alasan = this.rujukan["alasan"];
    this.kondisi = this.rujukan["kondisi"];
    this.terapi_diberikan = this.rujukan["terapi_diberikan"];
    this.penunjang = this.rujukan["penunjang"];
    this.terapi_diharapkan = this.rujukan["terapi_diharapkan"];

    if (value != null) {
      this.getRujukan();
    }
    // console.log("watch mdal", this.soap)
  }
  getRujukan() {
    appModule.setLoading(true);

    const dt = DataRujukan.getDataRujukanReg(this.register);
    dt.then(dt => {
      appModule.setLoading(false);

      this.dtRujukan = dt["data"];
    });
  }
  passTtd(value) {
    // console.log("ttd", value);

    this.$emit("passTtd", value);
    // this.modalTtd = false;
  }

  save() {
    // const svrujukan = this.staterujukandetail;
    // console.log("datarujuk", this.dtRujukan);
    // this.modalTtd = true;

    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      appModule.setLoading(true);
      if (this.dtRujukan["id"] != undefined) {
        const dt = DataRujukan.editDataRujukan(
          this.dtRujukan["id"],
          this.tujuan["id"],
          this.unit_tujuan_text,
          this.sess_login["id"],
          this.sess_login["unit_id"],
          this.register,
          this.rm,
          this.diagnosis,
          this.alasan,
          this.kondisi,
          this.terapi_diberikan,
          this.penunjang,
          this.terapi_diharapkan
        );
        dt.then(dt => {
          appModule.setLoading(false);

          // this.$emit('respRujukan',dt['data'])
          // console.log('err edit',dt)
          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            // console.log("dt edit", dt);
            storeRujukan.act_rujukan_on_reg(this.register);
            appModule.NoticeDelay("Berhasil Mengubah Surat Rujukan");
            // this.getRujukan();

            // this.textSnackBar = "Berhasil Mengubah Surat Rujukan"

            this.modalTtd = true;
          }
        });
        // this.dialog = false;
        this.closeDialog();
      } else {
        // console.log("simpan");
        const dt = DataRujukan.saveDataRujukan(
          this.tujuan["id"],
          this.unit_tujuan_text,
          this.sess_login["id"],
          this.sess_login["unit_id"],
          this.register,
          this.rm,
          this.diagnosis,
          this.alasan,
          this.kondisi,
          this.terapi_diberikan,
          this.penunjang,
          this.terapi_diharapkan
        );
        dt.then(dt => {
          appModule.setLoading(false);

          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            // console.log("dt simpan", dt);
            storeRujukan.act_rujukan_on_reg(this.register);
            appModule.NoticeDelay("Berhasil Menyimpan Surat Rujukan");
            // this.getRujukan();

            // this.textSnackBar = "Berhasil Menyimpan Surat Rujukan"
            this.modalTtd = true;
          }
        });
        // this.dialog = false
        // this.dialog = false;
        this.closeDialog();
      }
    }
  }
}
